module.exports = __webpack_public_path__ + "static/img/logo11.18d9d1a7.png";